module.exports = __webpack_public_path__ + "files/9ec3fcf1676a0476d07bb1d1cbf1cff2.png";